import React from 'react';

export const ImpressumContent: React.FC = () => {
  return (
    <div className="prose prose-lg max-w-none">
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-4">Angaben gemäß § 5 TMG</h2>
        <p>
          Beyond Pages<br />
          Glasstr. 84<br />
          50823 Köln
        </p>
      </section>

      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-4">Kontakt</h2>
        <p>
          E-Mail: info@beyondpages.io
        </p>
        <p className="mt-4">
          Geschäftsstelle Köln:<br />
          Glasstr. 84<br />
          50823 Köln Ehrenfeld
        </p>
      </section>

      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-4">Vertretungsberechtigter</h2>
        <p>
          Geschäftsführer: Dr.-Ing. Norman Ernst Kienzle<br />
          Registergericht: Amtsgericht Köln
        </p>
      </section>

      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-4">Umsatzsteuer-ID</h2>
        <p>
          Beyond Pages ist eine Marke der Banana Tea Labs
          Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
          DE 217 5144 9188
        </p>
      </section>

      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-4">Verantwortlich für den Inhalt</h2>
        <p>
          Dr.-Ing. Norman Ernst Kienzle<br />
          Banana Tea Labs<br />
          Glasstr. 84<br />
          50823 Köln
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-4">Streitschlichtung</h2>
        <p className="mb-4">
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
          <br />
          <a href="https://ec.europa.eu/consumers/odr" className="text-[#0055AA] hover:underline">
            https://ec.europa.eu/consumers/odr
          </a>
        </p>
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </section>
    </div>
  );
};

export default ImpressumContent;

